<template>
    <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="我的员工" name="first">
            <div class="main">

                <div class="emp_left">
                    <div id="hello-hello">
                        <p style="display:inline;float: left;line-height: 22px;"><b>部门列表</b></p>
                    </div>

                    <el-tree :data="departmentTree" node-key="id" default-expand-all :expand-on-click-node="false"
                        :highlight-current="true" @node-click="selectDeptClick">
                    </el-tree>
                </div>

                <div class="emp_right">
                    <div id="hello-hello">
                        <p style="display:inline;float: left;line-height: 22px;"><b>员工列表</b></p>

                        <div style="display:inline-block;width: 300px;">
                            <el-input placeholder="请输入姓名" v-model="queryValue" class="input-with-select">
                                <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
                            </el-input>
                        </div>

                        <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                            <el-button round type="primary" @click="openDrawer">添加员工</el-button>
                        </p>
                    </div>

                    <el-table :data="empList" style="width: 100%">
                        <el-table-column prop="employeeCode" label="代号" min-width="7%"></el-table-column>
                        <el-table-column prop="employeeName" label="姓名" min-width="10%"></el-table-column>

                        <el-table-column prop="label" label="部门" min-width="20%"></el-table-column>
                        <el-table-column prop="roleDescription" label="角色" min-width="27%"></el-table-column>

                        <!-- <el-table-column prop="status" label="状态" min-width="6%"></el-table-column> -->

                        <el-table-column prop="createdTime" label="添加时间" min-width="18%"></el-table-column>

                        <el-table-column fixed="right" label="操作" min-width="11%">
                            <template slot="header">
                                <el-tooltip class="item" effect="light" placement="top" content="公司归属者无法删除">
                                    <span>操作</span>
                                </el-tooltip>
                            </template>

                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>

                                <el-button @click="deleteClick(scope.row)" type="text" size="small" style="color:orange"
                                    v-if="scope.row.owner == 1 ? false : true">
                                    {{ scope.row.owner == 1 ? '' : '删除' }}
                                </el-button>

                                <el-button @click="disputeClick(scope.row)" type="text" size="small"
                                    v-if="scope.row.owner == 1 ? false : true">上报纠纷</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <div>
                        <el-pagination background :page-size="pageNum" :page-count="pageCount" :current-page="currPage"
                            layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                            :page-sizes="[8, 10, 15, 20]" @size-change="handleSizeChange" v-if="paginationIf">
                        </el-pagination>
                    </div>

                    <el-drawer title="添加员工" :visible.sync="drawerVisible" style="text-align: left;">
                        <el-row>
                            <el-col :span="9">
                                <div>
                                    <p style="display:inline-block;width:80px;text-align: center;">姓名</p>
                                    <el-input placeholder="请输入" v-model="employeeName" clearable
                                        style="display:inline-block;width:300px;margin-left: 10px;"></el-input>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="9">
                                <div>
                                    <p style="display:inline-block;width:80px;text-align: center;">手机号</p>
                                    <el-input placeholder="请输入" v-model="phone" clearable maxlength="11" show-word-limit
                                        style="display:inline-block;width:300px;margin-left: 10px;"
                                        :disabled="phoneDisable"></el-input>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="9">
                                <div>
                                    <p style="display:inline-block;width:80px;text-align: center;">身份证号</p>
                                    <el-input placeholder="请输入" v-model="identityCard" clearable maxlength="18"
                                        show-word-limit
                                        style="display:inline-block;width:300px;margin-left: 10px;"></el-input>
                                </div>
                            </el-col>
                        </el-row>

                        <p></p>

                        <el-row>
                            <el-col :span="9">
                                <div id="cancel_determine">
                                    <el-button round @click="drawerVisible = false">取消</el-button>
                                    <el-button round type="primary" @click="addEmp">确认</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-drawer>

                    <el-dialog title="纠纷详情" :visible.sync="dlgFormVisible" width="45%">

                        <div style="display:flex;margin-bottom: 10px;">
                            <p style="display:inline;width:15%">* 身份证号</p>
                            <div style="display:inline;width:40%;padding-right: 390px;">
                                    <el-input placeholder="请输入" v-model="form.identityCard" clearable maxlength="18"
                                        show-word-limit
                                        style="display:inline-block;width:300px;margin-left: 10px;"></el-input>
                            </div>
                        </div>

                        <div style="display:flex;margin-bottom: 10px;">
                            <p style="display:inline;width:15%">* 上传证明</p>
                            <div style="display:inline-block;width:25%">
                                <el-upload class="avatar-uploader" action="#" :http-request="upload"
                                    :show-file-list="false" :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">

                                    <img v-if="form.imgUrl" :src="'https://' + imagePath + form.imgUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>

                        </div>

                        <div style="display:flex;margin-bottom: 10px;">
                            <p style="display:inline;width:15%">备注</p>
                            <div style="display:inline;width:85%">
                                <el-input v-model="form.remark" autocomplete="off" type="textarea"
                                    style="width:100%"></el-input>
                            </div>
                        </div>

                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dlgFormVisible = false">取 消</el-button>
                            <el-button type="primary" @click="saveDisputeClick('ruleForm')">保 存</el-button>
                        </div>
                    </el-dialog>

                </div>
            </div>
        </el-tab-pane>

        <el-tab-pane label="员工背调" name="third">

        </el-tab-pane>
    </el-tabs>
</template>

<script>
import globalMethod from "@/method/globalMethod.js";

export default {
    name: "Employee",
    mixins: [globalMethod],
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            activeName: 'first',

            queryValue: '',

            loading: false,
            phoneDisable: false,

            departmentTree: [],
            drawerVisible: false,

            dlgFormVisible: false,
            form: {
                identityCard: '',
                imgUrl: '',
                imgFile: null,
                remark: ''
            },

            id: '',
            employeeName: '',
            phone: '',
            empList: [],
            deptId: '',

            identityCard: '',

            pageIndex: 0,
            pageNum: 8,
            total: 0,
            pageCount: 0,
            currPage: 1,

            paginationIf: true
        }
    },
    methods: {
        tabClick(tab, event) {

            console.log(tab, event)
        },
        upload(f) {

            this.form.imgFile = f.file
            this.form.imgUrl = ''
        },
        saveDisputeClick() {

        },
        disputeClick(row) {

            this.dlgFormVisible = true
        },
        searchOrder(query) {
            this.empList = []
            this.pageIndex = 0

            if (this.queryValue !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false

                    this.getAll()
                }, 200)

            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        selectDeptClick(node, data) {

            this.paginationIf = false

            this.deptId = node.id

            this.currPage = 1

            setTimeout(() => {
                this.paginationIf = true
            }, 300)

            this.pageClick(1)
        },
        openDrawer() {
            this.id = ''
            this.employeeName = ''
            this.phone = ''

            this.phoneDisable = false
            this.drawerVisible = true
        },
        addEmp() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/add",
                data: {
                    id: this.id,
                    employeeName: this.employeeName,
                    phone: this.phone,
                    identityCard: this.identityCard,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 200) {
                    this.addEmpDrawer = false
                }

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll()
            })
        },
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll",
                data: {
                    queryParam: this.queryValue,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.empList = data.data

                for (let key in this.empList) {
                    this.empList[key].employeeCode = '0' + this.empList[key].employeeCode

                    this.empList[key].createdTime = this.$moment(this.empList[key].createdTime).format("YYYY-MM-DD HH:mm")
                    this.empList[key].status = this.empList[key].status == 1 ? '启用' : '禁用'
                }

                this.total = this.empList[0].total
            })
        },
        getByDept() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll/deptId",
                data: {
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    deptId: this.deptId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 200) {
                    this.$message({
                        type: 'success',
                        message: data.msg
                    })
                }

                this.empList = data.data
                this.total = this.empList.length == 0 ? 0 : this.empList[0].total

                for (let key in this.empList) {
                    this.empList[key].employeeCode = '0' + this.empList[key].employeeCode

                    this.empList[key].createdTime = this.$moment(this.empList[key].createdTime).format("YYYY-MM-DD HH:mm")
                    this.empList[key].status = this.empList[key].status == 1 ? '启用' : '禁用'
                }

            })
        },
        handleClick(row) {

            this.id = row.id
            this.employeeName = row.employeeName
            this.phone = row.phone

            this.phoneDisable = true
            this.drawerVisible = true
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeEmp(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        removeEmp(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/employee/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll()
            })
        },
        pageClick(currentPage) {

            this.empList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            if (this.deptId == '') {

                this.getAll()
            } else {

                this.getByDept()
            }
        },
        handleSizeChange(val) {

            this.pageNum = val

            if (this.deptId == '') {

                this.getAll()
            } else {

                this.getByDept()
            }
        },
    },
    mounted() {
        this.setDefaultPath('/employee')

        this.getAll()

        this.departmentTree = this.getDepartmentTree({
            companyId: this.companyId
        }, this.token)
    }
}
</script>

<style>
.emp_left {
    width: 22%;
    height: 550px;
    display: inline;
    float: left;
}

.emp_right {
    width: 76%;
    display: inline;
    float: right;
}

.emp_p {
    position: relative;
    right: 5px;
    width: 120px;
    margin: 10px 0px 30px 0px;
}

.el-pagination__total {
    color: green;
}

.avatar-uploader {
    width: 142px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}
</style>